enum ReturnPolicys {
  External = 'EXTERNAL',
  None = 'NONE',
  StorePolicy = 'STORE_POLICY',
}

type JSONTrackingConfig = {
  recommendation_title: Maybe<string>;
  recommendation_title_tracking: Maybe<string>;
  return_policy_source: Maybe<string>;
  return_policy_url: Maybe<string>;
  spotlight_title: Maybe<string>;
};

type TrackingConfig = {
  recommendationTitle: Maybe<string>;
  recommendationTitleTracking: Maybe<string>;
  returnPolicySource: Maybe<string>;
  returnPolicyUrl: Maybe<string>;
  spotlightTitle: Maybe<string>;
};

type BrandAndFooter = {
  recommendationTitle?: Maybe<string>;
  replyToEmail: Maybe<string>;
  returnPolicySource: Maybe<string>;
  returnPolicyUrl?: Maybe<string>;
  spotlightTitle?: Maybe<string>;
};

const setTrackingConfigPayload = (trackingConfig: TrackingConfig, payload: BrandAndFooter) => ({
  recommendationTitle: payload.recommendationTitle,
  recommendationTitleTracking: trackingConfig.recommendationTitleTracking,
  returnPolicySource: payload.returnPolicySource,
  returnPolicyUrl: payload.returnPolicyUrl,
  spotlightTitle: payload.spotlightTitle,
});
const fromJSON = (jsonTrack: JSONTrackingConfig): TrackingConfig => ({
  recommendationTitle: jsonTrack.recommendation_title,
  recommendationTitleTracking: jsonTrack.recommendation_title_tracking,
  returnPolicySource: jsonTrack.return_policy_source,
  returnPolicyUrl: jsonTrack.return_policy_url,
  spotlightTitle: jsonTrack.spotlight_title,
});

const toJSON = (jsonTrack: TrackingConfig): JSONTrackingConfig => ({
  recommendation_title: jsonTrack.recommendationTitle || null,
  recommendation_title_tracking: jsonTrack.recommendationTitleTracking || null,
  return_policy_source: jsonTrack.returnPolicySource || ReturnPolicys.None,
  return_policy_url:
    jsonTrack.returnPolicySource === ReturnPolicys.External ? jsonTrack.returnPolicyUrl : null,
  spotlight_title: jsonTrack.spotlightTitle || null,
});

export {
  BrandAndFooter,
  JSONTrackingConfig,
  ReturnPolicys,
  TrackingConfig,
  fromJSON,
  setTrackingConfigPayload,
  toJSON,
};
